import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { VehicleBrand } from "../_types/vehicleBrand";

@Injectable({
    providedIn: 'root',
})

export class VehiclesBrandsService extends Service<VehicleBrand> {
  public override type = 'vehicleBrands';
  public override url = 'providers/vehicleBrands'; 
    
}
